// All UI copy in EN + FR. Brand & team copy lives in their respective data files.
export const translations = {
  en: {
    common: {
      whatsappLabel: "WhatsApp",
    },
    nav: {
      brands: "Brands",
      services: "Services",
      team: "Team",
      contact: "Contact",
      startProject: "Start a project",
    },
    hero: {
      livePrefix: "Live ·",
      livePillSuffix: "txns processed",
      swissBuilt: "Swiss‑built · since 2013",
      titleLead: "A ",
      titleHighlight: "fintech and SaaS",
      titleTail: " studio powering operational excellence.",
      sub: "We design, ship and operate the rails behind modern Swiss businesses — payments, custom web & mobile, productivity boosters. One of the few agencies in the region that ",
      subBold: "owns the products it builds",
      subEnd: ".",
      cta1: "Explore our brands",
      cta2: "Talk to a founder",
      portfolio: "Our portfolio",
      capabilities: [
        "Payments infrastructure",
        "Custom web & mobile",
        "POS & ordering",
        "CRM & marketing",
        "Branding & design",
        "Web security",
        "Print & large format",
      ],
    },
    stats: {
      pill: "By the numbers",
      titleLead: "Quietly powering Swiss commerce — ",
      titleHighlight: "at scale",
      titleTail: ".",
      paragraph:
        "We don't just talk about excellence. We measure it — every transaction, every release, every line of code that ships from Neuchâtel to the world.",
      live: "Live",
      items: {
        years: { label: "Years in market", hint: "Building since 2013" },
        saas: { label: "Successful SaaS shipped", hint: "Owned & operated by us" },
        tx: { label: "Transactions processed", hint: "Counting up live, right now" },
        vol: { label: "Weekly volume", hint: "CHF cleared every week" },
      },
    },
    about: {
      pill: "Why us",
      titleLead: "Few agencies ",
      titleEm: "own",
      titleMid: " their products.",
      titleHighlight: "We do.",
      paragraph:
        "That changes everything. We solve our clients' problems with the same tools we trust to run our own SaaS — battle‑tested, supported and improved every single week.",
      hqLabel: "Headquartered",
      hqValue: "Switzerland",
      hqHint: "Neuchâtel · Worldwide",
      opLabel: "Operating",
      opValue: "10 brands",
      opHint: "All in‑house, all live",
      pillars: [
        {
          title: "Pioneers in design",
          desc: "Considered, distinctive, useful — design that lifts brands instead of decorating them.",
        },
        {
          title: "Excellence in development",
          desc: "Architected to last. Web, mobile and SaaS engineered for performance, scale and security.",
        },
        {
          title: "Payments at the core",
          desc: "We move money — clearing 2.5M CHF every week through our own fintech rails.",
        },
        {
          title: "Productivity boosters",
          desc: "POS, CRM, ordering, marketing — we ship the boring software that makes operators rich.",
        },
      ],
    },
    brands: {
      pill: "Our brands",
      titleLead: "10 products. ",
      titleHighlight: "One studio.",
      paragraph:
        "Every tile is a live business — a SaaS, a platform, a payment rail. Each in its own brand colour, each owned and operated by Web Print Media.",
      visitSite: "Visit site",
      categories: {
        All: "All",
        Payments: "Payments",
        SaaS: "SaaS",
        Platform: "Platform",
        POS: "POS",
        CRM: "CRM",
        Marketing: "Marketing",
        Security: "Security",
        Agency: "Agency",
        Theme: "Theme",
      },
    },
    savings: {
      pill: "SwissPayout · Savings calculator",
      titleLead: "Pay ",
      titleEm: "half",
      titleTail: " what you pay Stripe.",
      paragraphLead: "SwissPayout clears ",
      paragraphBold: "2.5M CHF every week",
      paragraphTail:
        " on our own rails — that scale lets us pass the savings back to you. Run the numbers below with your real volume.",
      bullets: [
        "No monthly fee for big volumes",
        "200+ payment methods, Swiss‑hosted",
        "Same‑day onboarding for verified merchants",
        "PCI‑DSS · QR‑bill · TWINT · Apple/Google Pay",
      ],
      monthlyVolume: "Monthly volume",
      avgTicket: "Average ticket",
      compareAgainst: "Compare against",
      theirFees: (name) => `${name} fees`,
      ourFees: "SwissPayout fees",
      youSave: "You save",
      txnsHint: (pct, fixed, txns) => `${pct}% + ${fixed} · ~${txns} txns`,
      sameVolumeHint: (pct, fixed) => `${pct}% + ${fixed} · same volume`,
      everyYear: (amt) => `${amt} every year`,
      disclaimer:
        "Illustrative blended rates for comparison. Your actual SwissPayout pricing depends on volume, MCC and risk profile — request a quote.",
      cta: "Get my custom rate",
    },
    team: {
      pill: "The studio",
      titleLead: "Built by ",
      titleHighlight: "Senior Operators",
      titleTail: ".",
      paragraph:
        "No juniors on your project. A tight, senior team — design, engineering, finance and operations in one room. Decades of shipping Swiss software, fintech rails and SaaS that scales.",
    },
    contact: {
      pill: "Say hi",
      titleLead: "Let's build the ",
      titleEm: "next one",
      titleTail: " together.",
      paragraph:
        "Tell us about your project, your numbers and what's keeping you up at night. We respond within 24 hours — sometimes much faster.",
      call: "Call",
      email: "Email",
      whatsapp: "WhatsApp",
      whatsappValue: "+41 79 315 06 00",
      firstName: "First name",
      lastName: "Last name",
      emailField: "Email",
      phone: "Phone",
      message: "Message",
      placeholder: "Tell us about your project…",
      privacy:
        "By sending you agree to our use of your data to reply. We never share it.",
      submit: "Send message",
      submitting: "Sending…",
      successToast: "Message sent — we'll respond within 24 hours.",
      errorToast: "Something went wrong. Please try again or call us.",
    },
    footer: {
      tagline: "AI · Fintech · SaaS",
      intro:
        "More than a web agency. A studio that owns, ships and operates the software powering modern businesses in Switzerland & beyond.",
      colStudio: "Studio",
      colFeatured: "Featured products",
      colMore: "More products",
      copyright: "All rights reserved.",
      imprint: "Imprint",
      allOperational: "All systems operational",
    },
    imprint: {
      pill: "Legal",
      title: "Imprint",
      sub: "Information in accordance with applicable Swiss law.",
      responsible: "Responsible for content",
      company: "Web & Print Media Switzerland Sàrl",
      address: ["Rue des Saars 115", "2000 Neuchâtel", "Switzerland"],
      phone: "Phone",
      email: "Email",
      whatsapp: "WhatsApp",
      hq: "Headquarters",
      hqValue: "Neuchâtel · Switzerland",
      copyParagraph:
        "All content on this website — including text, graphics, logos and imagery — is the property of Web & Print Media Switzerland Sàrl unless otherwise stated, and is protected by Swiss and international copyright law.",
      brandsParagraph:
        "Brand names and trademarks referenced (SwissPayout, Bookers, Sentricor, Chaslay, Connector, O'Javana, SocialBase, Brand Concepts, Professional Designers) are operated and owned by Web & Print Media Switzerland Sàrl or its affiliated entities.",
      linksParagraph:
        "Despite careful editorial control, we assume no liability for the content of external links. The operators of linked pages are solely responsible for their content.",
      back: "Back to home",
    },
    widget: {
      callMeBack: "Call me back",
      close: "Close",
      talkToUs: "Talk to us",
      tagline: "We answer in under 24h.",
      tabCallback: "Callback",
      tabContact: "Contact page",
      yourName: "Your name",
      phone: "Phone",
      bestTime: "Best time to call",
      bestTimePlaceholder: "Tomorrow, 10–12 CET",
      requestCallback: "Request callback",
      sending: "Sending…",
      callNow: "Call now",
      preferFullForm:
        "Prefer the full contact form? Send us a detailed brief, files or specs — we usually respond the same day.",
      openContactForm: "Open contact form",
      successToast: "Got it. We'll call you back shortly.",
      errorToast: "Could not send. Please try again.",
    },
  },

  // ───────────────────────── FRENCH ─────────────────────────
  fr: {
    common: {
      whatsappLabel: "WhatsApp",
    },
    nav: {
      brands: "Marques",
      services: "Services",
      team: "Équipe",
      contact: "Contact",
      startProject: "Démarrer un projet",
    },
    hero: {
      livePrefix: "En direct ·",
      livePillSuffix: "transactions traitées",
      swissBuilt: "Conçu en Suisse · depuis 2013",
      titleLead: "Un studio ",
      titleHighlight: "fintech et SaaS",
      titleTail: " au service de l'excellence opérationnelle.",
      sub: "Nous concevons, déployons et exploitons l'infrastructure des entreprises suisses modernes — paiements, web & mobile sur mesure, outils de productivité. L'une des rares agences de la région qui ",
      subBold: "possède les produits qu'elle développe",
      subEnd: ".",
      cta1: "Découvrir nos marques",
      cta2: "Parler à un fondateur",
      portfolio: "Notre portefeuille",
      capabilities: [
        "Infrastructure de paiement",
        "Web & mobile sur mesure",
        "Caisse & commande",
        "CRM & marketing",
        "Branding & design",
        "Sécurité web",
        "Impression & grand format",
      ],
    },
    stats: {
      pill: "En chiffres",
      titleLead: "Au service silencieux du commerce suisse — ",
      titleHighlight: "à grande échelle",
      titleTail: ".",
      paragraph:
        "Nous ne nous contentons pas de parler d'excellence. Nous la mesurons — chaque transaction, chaque déploiement, chaque ligne de code qui part de Neuchâtel vers le monde.",
      live: "En direct",
      items: {
        years: { label: "Années sur le marché", hint: "En activité depuis 2013" },
        saas: { label: "SaaS lancés avec succès", hint: "Détenus et opérés par nous" },
        tx: { label: "Transactions traitées", hint: "En direct, en ce moment même" },
        vol: { label: "Volume hebdomadaire", hint: "CHF traités chaque semaine" },
      },
    },
    about: {
      pill: "Pourquoi nous",
      titleLead: "Peu d'agences ",
      titleEm: "possèdent",
      titleMid: " leurs produits.",
      titleHighlight: "Nous, oui.",
      paragraph:
        "Cela change tout. Nous résolvons les problèmes de nos clients avec les mêmes outils que ceux qui font tourner nos propres SaaS — éprouvés, maintenus et améliorés chaque semaine.",
      hqLabel: "Siège social",
      hqValue: "Suisse",
      hqHint: "Neuchâtel · International",
      opLabel: "En activité",
      opValue: "10 marques",
      opHint: "Toutes internes, toutes actives",
      pillars: [
        {
          title: "Pionniers du design",
          desc: "Réfléchi, distinctif, utile — un design qui élève les marques au lieu de les décorer.",
        },
        {
          title: "Excellence en développement",
          desc: "Conçu pour durer. Web, mobile et SaaS pensés pour la performance, l'échelle et la sécurité.",
        },
        {
          title: "Le paiement au cœur",
          desc: "Nous faisons circuler l'argent — 2,5M CHF traités chaque semaine sur nos propres rails fintech.",
        },
        {
          title: "Boosters de productivité",
          desc: "Caisse, CRM, commande, marketing — nous livrons le logiciel discret qui enrichit les exploitants.",
        },
      ],
    },
    brands: {
      pill: "Nos marques",
      titleLead: "10 produits. ",
      titleHighlight: "Un seul studio.",
      paragraph:
        "Chaque tuile est une entreprise active — un SaaS, une plateforme, un rail de paiement. Chacune dans sa propre couleur, toutes détenues et exploitées par Web Print Media.",
      visitSite: "Voir le site",
      categories: {
        All: "Toutes",
        Payments: "Paiements",
        SaaS: "SaaS",
        Platform: "Plateforme",
        POS: "Caisse",
        CRM: "CRM",
        Marketing: "Marketing",
        Security: "Sécurité",
        Agency: "Agence",
        Theme: "Thème",
      },
    },
    savings: {
      pill: "SwissPayout · Calculateur d'économies",
      titleLead: "Payez ",
      titleEm: "la moitié",
      titleTail: " de ce que vous payez à Stripe.",
      paragraphLead: "SwissPayout traite ",
      paragraphBold: "2,5M CHF chaque semaine",
      paragraphTail:
        " sur nos propres rails — cette échelle nous permet de vous rendre les économies. Lancez les calculs ci‑dessous avec votre volume réel.",
      bullets: [
        "Aucun frais mensuel pour les gros volumes",
        "Plus de 200 méthodes de paiement, hébergées en Suisse",
        "Activation le jour même pour les commerçants vérifiés",
        "PCI‑DSS · QR‑facture · TWINT · Apple/Google Pay",
      ],
      monthlyVolume: "Volume mensuel",
      avgTicket: "Panier moyen",
      compareAgainst: "Comparer avec",
      theirFees: (name) => `Frais ${name}`,
      ourFees: "Frais SwissPayout",
      youSave: "Vous économisez",
      txnsHint: (pct, fixed, txns) => `${pct} % + ${fixed} · ~${txns} transactions`,
      sameVolumeHint: (pct, fixed) => `${pct} % + ${fixed} · même volume`,
      everyYear: (amt) => `${amt} chaque année`,
      disclaimer:
        "Tarifs indicatifs à des fins de comparaison. Votre tarif SwissPayout réel dépend du volume, du MCC et du profil de risque — demandez un devis.",
      cta: "Obtenir mon tarif personnalisé",
    },
    team: {
      pill: "Le studio",
      titleLead: "Bâti par ",
      titleHighlight: "des Opérateurs Seniors",
      titleTail: ".",
      paragraph:
        "Aucun junior sur votre projet. Une équipe senior soudée — design, ingénierie, finance et opérations dans une même pièce. Des décennies d'expérience à livrer du logiciel suisse, des rails fintech et des SaaS qui passent à l'échelle.",
    },
    contact: {
      pill: "Dites bonjour",
      titleLead: "Construisons le ",
      titleEm: "prochain",
      titleTail: " ensemble.",
      paragraph:
        "Parlez‑nous de votre projet, de vos chiffres et de ce qui vous empêche de dormir. Nous répondons sous 24 heures — souvent bien plus vite.",
      call: "Téléphone",
      email: "E‑mail",
      whatsapp: "WhatsApp",
      whatsappValue: "+41 79 315 06 00",
      firstName: "Prénom",
      lastName: "Nom",
      emailField: "E‑mail",
      phone: "Téléphone",
      message: "Message",
      placeholder: "Parlez‑nous de votre projet…",
      privacy:
        "En envoyant, vous acceptez que nous utilisions vos données pour vous répondre. Nous ne les partageons jamais.",
      submit: "Envoyer le message",
      submitting: "Envoi…",
      successToast: "Message envoyé — nous vous répondrons sous 24 heures.",
      errorToast: "Une erreur est survenue. Réessayez ou appelez‑nous.",
    },
    footer: {
      tagline: "AI · Fintech · SaaS",
      intro:
        "Plus qu'une agence web. Un studio qui possède, déploie et exploite les logiciels qui propulsent les entreprises modernes en Suisse et au‑delà.",
      colStudio: "Studio",
      colFeatured: "Produits phares",
      colMore: "Autres produits",
      copyright: "Tous droits réservés.",
      imprint: "Mentions légales",
      allOperational: "Tous les systèmes opérationnels",
    },
    imprint: {
      pill: "Légal",
      title: "Mentions légales",
      sub: "Informations conformes au droit suisse applicable.",
      responsible: "Responsable du contenu",
      company: "Web & Print Media Switzerland Sàrl",
      address: ["Rue des Saars 115", "2000 Neuchâtel", "Suisse"],
      phone: "Téléphone",
      email: "E‑mail",
      whatsapp: "WhatsApp",
      hq: "Siège social",
      hqValue: "Neuchâtel · Suisse",
      copyParagraph:
        "L'ensemble du contenu de ce site — textes, graphismes, logos et images — est la propriété de Web & Print Media Switzerland Sàrl, sauf mention contraire, et est protégé par le droit d'auteur suisse et international.",
      brandsParagraph:
        "Les marques et noms commerciaux mentionnés (SwissPayout, Bookers, Sentricor, Chaslay, Connector, O'Javana, SocialBase, Brand Concepts, Professional Designers) sont exploités et détenus par Web & Print Media Switzerland Sàrl ou ses entités affiliées.",
      linksParagraph:
        "Malgré un contrôle éditorial rigoureux, nous déclinons toute responsabilité quant au contenu des liens externes. Les opérateurs des pages liées sont seuls responsables de leur contenu.",
      back: "Retour à l'accueil",
    },
    widget: {
      callMeBack: "Rappelez‑moi",
      close: "Fermer",
      talkToUs: "Parlons",
      tagline: "Nous répondons en moins de 24 h.",
      tabCallback: "Rappel",
      tabContact: "Page contact",
      yourName: "Votre nom",
      phone: "Téléphone",
      bestTime: "Meilleur moment pour appeler",
      bestTimePlaceholder: "Demain, 10 h–12 h CET",
      requestCallback: "Demander un rappel",
      sending: "Envoi…",
      callNow: "Appeler",
      preferFullForm:
        "Vous préférez le formulaire complet ? Envoyez‑nous un brief détaillé, des fichiers ou des spécifications — nous répondons généralement le jour même.",
      openContactForm: "Ouvrir le formulaire",
      successToast: "C'est noté. Nous vous rappelons rapidement.",
      errorToast: "Impossible d'envoyer. Réessayez.",
    },
  },
};
